module.exports = __webpack_public_path__ + "img/Select.fe43a9ec.svg";